<div class="footer__credits">
  <span class="footer__credit" test-id="footerCredit">
    City Pantry Ltd trading as Just Eat for Business &copy; {{ currentYear }}.
  </span>
</div>
